module.exports = __webpack_public_path__ + "img/pocket-2_jp.8e7755e.jpg";